module.exports = new __parcel__URL__("lumoa.034c7273.png").toString();